import React, { Component } from 'react'
import {
  Form, Input, Button, message
} from 'antd'
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux'
import Password from 'antd/lib/input/Password';

import ImeiPasswordAPI from '@/API/imeiPassword'

class PasswordToDelete extends Component {
  constructor(props) {

    super(props);
    this.state = {
      form: {
        deviceId: ''
      },
      password: ''
    };
  }
  handleGetPassword() {
    ImeiPasswordAPI.get(this.state.form).then((res) => {
      if (res.code) {
        //message.error(res.info)
      } else {
        this.setState({ password: res.data })
      }
    })
  }
  handleDeviceIdChange(e) {
    this.setState({
      form: {
        deviceId: e.target.value
      }
    })
  }
  render() {
    const { form, password } = this.state
    const { t } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 },
      },
    }
    return (
      <div style={{ padding: 20 }}>
        <Form style={{ width: 500 }} {...formItemLayout}>
          <Form.Item label={t("IMEI")}>
            <Input defaultValue={form.deviceId} onChange={(e) => { this.handleDeviceIdChange(e) }}></Input>
            <Button type="primary" onClick={() => { this.handleGetPassword() }}>{t('Get Password')}</Button>
          </Form.Item>
          <Form.Item label={t("PASSWORD")}>
            {password}
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    roleId: state.roleId,
  }
}

export default connect(mapStateToProps)(withTranslation()(PasswordToDelete));